import Component from 'gia/Component'
import eventbus from 'gia/eventbus';
import stage from '../components/stage'
import renderer from '../components/render'
import _each from 'lodash.foreach'
import gsap from 'gsap'
import Flickity from 'flickity'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

class Marker extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.html = $('html')
    this.menu = $('.menu')
    this.element = element
    this.el = $(element)


    this.ref = {
        point: [],
        menu: [],
        marker: null,
        news: null,
        list: null,
        pin: null,
        item: []
    }

  }

  mount() {

    this.resizeQue = this.resize.bind(this)
    stage.on("stage:resize", this.resizeQue);
    this.resize(stage)




  //   if(this.ref.list) {
  //
  //     this.items = this.ref.item.length - 3
  //     const snap = []
  //     this.ref.item.forEach((elm, j) => {
  //       if(j < this.ref.item.length - 2 ){snap.push((j * 1/this.items).toFixed(3))}
  //     });
  //     const step = 1/this.items
  //     let current = 0;
  //
  //     let last = 0;
  //
  //
  //     ScrollTrigger.matchMedia({
  //
  //     // desktop
  //     "(min-width: 800px)": ()=> {
  //       ScrollTrigger.create({
  //         trigger: this.ref.news,
  //         endTrigger: this.ref.pin,
  //         start: "top top",
  //         end: "bottom bottom",
  //         pin: true,
  //         pinSpacing: false,
  //         anticipatePin: 1
  //       });
  //
  //       gsap.to(this.ref.list, {
  //         xPercent: -100,
  //         x: () => innerWidth,
  //         ease: "none",
  //         scrollTrigger: {
  //           trigger: this.ref.pin ,
  //           start: "top top-=30%",
  //           end: "bottom bottom+=15%",
  //           scrub: .21,
  //           invalidateOnRefresh: true,
  //           onUpdate: self => {
  //
  //             const p = self.progress.toFixed(3)
  //             current = gsap.utils.snap(snap, p)/step
  //
  //           //  console.log(p, current, step);
  //
  //
  //             if(current != last ) {
  //               $('.op--inview').removeClass('op--inview')
  //               $(this.ref.item[current + 1]).addClass('op--inview')
  //               last = current
  //             }
  //           }
  //         }
  //       });
  //     },
  //
  //     // mobile
  //     "(max-width: 799px)": ()=> {
  //       gsap.to(this.ref.list, {
  //
  //         xPercent: -100,
  //         x: () => innerWidth,
  //         ease: "none",
  //         scrollTrigger: {
  //           trigger: this.ref.news ,
  //           start: "top top",
  //           end: "bottom top-=75%",
  //           scrub: .21,
  //           pin: true,
  //           //pinSpacing: true,
  //           pinSpacer: this.ref.pin,
  //           invalidateOnRefresh: true,
  //           anticipatePin: 1
  //         }
  //       });
  //     }
  // })
  //
  //   }




      this.marker = $(this.ref.marker)

      this.ref.point.forEach((panel, i) => {
      ScrollTrigger.create({
        trigger: panel,
        start: `${panel.dataset.start}`,
        end: panel.dataset.end ? `${panel.dataset.end}` : "bottom bottom",
      //  markers: true,
        sinvalidateOnRefresh: true,
        onEnter: () => {
              this.marker.addClass('is-visible')
              this.ref.marker.innerHTML = panel.dataset.section;
        },
        onLeave: () => {
              this.marker.removeClass('is-visible')
              this.ref.marker.innerHTML = '';
        },
        onLeaveBack: () => {
          this.marker.removeClass('is-visible')
            this.ref.marker.innerHTML = '';
        },
        onEnterBack: () => {
          this.marker.addClass('is-visible')
            this.ref.marker.innerHTML = panel.dataset.section;
        }
      });
    });


    this.ref.menu.forEach((panel, i) => {
    ScrollTrigger.create({
      trigger: panel,
      start: 'top top+=20px',
      end: "bottom top",
      //markers: true,
      invalidateOnRefresh: true,
      onEnter: () => {
        this.body.addClass($(panel).data('menu'))
      },
      onLeave: () => {
        if($(panel).data('menu') != "menu-normal"){
          this.body.removeClass($(panel).data('menu'))
        }

      },
      onLeaveBack: () => {
        this.body.removeClass($(panel).data('menu'))
      },
      onEnterBack: () => {
        this.body.addClass($(panel).data('menu'))
      }
    });
  });






    //move to news
    $('.journey .portfolio-filters a').on('click', (e)=>{
      e.preventDefault()
      var t = $(e.currentTarget)
      $('.journey .portfolio-filters a').removeClass('selected')
      t.addClass('selected')
      $('.logos.selected').removeClass('selected')
      var href = t.attr('href')
      $(`${href}`).addClass('selected')
      ScrollTrigger.refresh()
    })

  //  this.resize()

  }



  resize(e){



  }

  render(e){

  }




  unmount() {
  const triggers = ScrollTrigger.getAll( )
  triggers.forEach((trig, i) => {
    trig.kill()
  })

    stage.removeListener("stage:resize", this.resizeQue);
    // stage.removeListener("stage:scroll", this.renderQue);
    //this.roll.unmount()

  }


}

module.exports = Marker
